/**
 * @module errors
 *
 * Tools for creating errors, organizing them by type, and verifying them.
 */

// A set of pre-defined re-usable error names.
const types = {
  generic: 'GenericError',
  tokenExpired: 'TokenExpiredError',
  activation: 'ActivationError',
};

type CreateErrorOptions = {
  name?: string | null;
  message?: string;
};

// Optionally provide a `name` property to override the default created by Error.
const createError = ({ name = null, message = 'Something went wrong' }: CreateErrorOptions): Error => {
  const error: Error = new Error(message);

  if (name) error.name = name;

  return error;
};

export const errors = {
  types,
  createError,
};
